import styled from 'styled-components';
import { useRouter } from 'next/router';
import { useState } from 'react';

import { CloseX } from 'shared/icons/CloseX';
import { SearchTitle } from 'search/styles/SearchStyles';
import { UnorderedList } from 'shared/components/UnorderedList';
import { variableFontRegular } from 'styles/theme/text';
import { RecentSearchesCache } from 'search/utils/RecentSearchesCache';
import { t } from 'localization/utils/t';

const TP = 'search.components.search.RecentSearches';

export const RecentSearches = () => {
  const router = useRouter();
  const [recentSearches, setRecentSearches] = useState(RecentSearchesCache.list());

  const handleRemove = (recentSearch) => {
    setRecentSearches((prevState) => prevState.filter((search) => search !== recentSearch));
    RecentSearchesCache.remove(recentSearch);
  };

  const handleClick = (link: string) => {
    void router.push(link);
  };

  if (recentSearches.length === 0) {
    return null;
  }

  return (
    <RecentSearches.Wrapper>
      <RecentSearches.Title>{t(`${TP}.title`, 'Your recent searches')}</RecentSearches.Title>
      <UnorderedList>
        {recentSearches.map((recentSearch) => {
          try {
            const { text, link } = JSON.parse(recentSearch);
            return (
              <RecentSearches.ListItem key={recentSearch}>
                <RecentSearches.Item onClick={() => handleClick(link)}>{text}</RecentSearches.Item>
                <RecentSearches.Remove
                  aria-label={t(`${TP}.remove`, 'Remove')}
                  data-qa="remove_button"
                  onClick={() => handleRemove(recentSearch)}
                  type="button"
                >
                  <CloseX title={t(`${TP}.remove`, 'Remove')} />
                </RecentSearches.Remove>
              </RecentSearches.ListItem>
            );
          } catch {
            return null;
          }
        })}
      </UnorderedList>
    </RecentSearches.Wrapper>
  );
};

RecentSearches.Wrapper = styled.div``;

RecentSearches.Title = styled(SearchTitle)`
  ${SearchTitle};
  margin-bottom: 16px;
`;

RecentSearches.ListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  ${variableFontRegular({ size: '11.5px', height: '16px' })};

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    ${variableFontRegular({ size: '11.5px', height: '14px' })};
  }
`;

RecentSearches.Item = styled.button`
  width: 100%;
  text-align: left;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

RecentSearches.Remove = styled.button`
  padding: 0;
  cursor: pointer;
`;
